// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1198":"b05cbb47","7886":"15b920dc"}[chunkId] + ".chunk.css";
};